import * as React from 'react'
import { Container } from 'reactstrap'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { SelectWithLabel } from 'components/Form'
import { nauta } from 'api'
import ProcessesList from './ProcessesList'
import ProcessesDetail from './ProcessesDetail'
import ModalDelete from 'components/ModalDelete'
import { getStaticImage } from 'utils/statics'

const Index = () => {
  const [processes, setProcesses] = React.useState([])
  const [order, setOrder] = React.useState({ value: 'asc', label: I18n.t('order_by_az') })
  const [isOpenModal, setIsOpenModal] = React.useState(false)
  const [isOpenModalDelete, setIsOpenModalDelete] = React.useState(false)
  const orderOptions = [{ value: 'asc', label: I18n.t('order_by_az') }, { value: 'desc', label: I18n.t('order_by_za') }]
  const [valuesToEdit, setValuesToEdit] = React.useState({})
  const [processToRemove, setProcessToRemove] = React.useState({})
  const [removing, setRemoving] = React.useState(false)
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  React.useEffect(()=> {
    getProcesses()
  }, [])

  React.useEffect(()=> {
    if (!isOpenModal)
      setValuesToEdit({})
  }, [isOpenModal])

  const getProcesses = () => {
    nauta.get('').then(result => {
      sort(order.value, result.data)
    }).catch(error => {
      console.error(error)
    })
  }

  const save = (process) => {
    setIsSubmitting(true)
    const data = {
      _id: process._id,
      label: process.label,
      processId: process.processId,
      type: 'nauta',
      processVars: process.processVars,
    }
    if (data._id) {
      nauta.put(data._id, data).then(result => {
        setIsOpenModal(false)
        getProcesses()
        setIsSubmitting(false)
      }).catch(error => {
        setIsSubmitting(false)
        console.error(error)
      })
    }
    else {
      nauta.post(data).then(result => {
        setIsOpenModal(false)
        getProcesses()
        setIsSubmitting(false)
      }).catch(error => {
        setIsSubmitting(false)
        console.error(error)
      })
    }
  }

  const openModalToEdit = (values) => {
    setValuesToEdit(values)
    setIsOpenModal(true)
  }

  const deleteProcess = (values) => {
    setRemoving(true)
    nauta.remove(values._id).then(result => {
      getProcesses()
      setIsOpenModalDelete(false)
      setProcessToRemove({})
      setRemoving(false)
    }).catch(error => {
      setIsOpenModalDelete(false)
      setProcessToRemove({})
      setRemoving(false)
      console.error(error)
    })
  }

  const onChange = (value, type) => {
    setOrder(value)
    sort(value.value, processes)
  }

  const sort = (order, data) => {
    setProcesses(data.sort((a, b) => order === 'asc' ? a.label.localeCompare(b.label) : a.label.localeCompare(b.label)*-1 ))
  }

  return (
    <div className='animated fadeIn'>
      <Container fluid className='py-5 processes-configuration'>
        <div className='wrapper-processes section mb-4'>
          <h1>{'Nauta'}</h1>
          <legend dangerouslySetInnerHTML={{ __html: 'Gestiona los procesos de nauta' }} />

          <div className='seccion-1'>
            <div className='wrapper-order'>
              <label htmlFor={'order'}>{I18n.t('dashboard_order-by')}</label>
              <SelectWithLabel
                name='order'
                options={orderOptions}
                value={order}
                onChange={(value)=>onChange(value, 'order')}
                classNameWrapper='processes-order'
              />
            </div>
          </div>

          <div className='seccion-2'>
            <ProcessesList
              processes={processes}
              edit={openModalToEdit}
              remove={(values)=>{setIsOpenModalDelete(true); setProcessToRemove(values)}}
            />
          </div>
          <div className={`add-process`} onClick={()=>{setIsOpenModal(true)}}>
            <img src={getStaticImage('/icons/orange-brand/icon-add.svg')} alt='Add process'/>
            <span>{'Añadir proceso'}</span>
          </div>


          {isOpenModal && <ProcessesDetail
            processes={processes}
            isOpen={isOpenModal}
            toggle={()=>setIsOpenModal(!isOpenModal)}
            save={save}
            valuesToEdit={valuesToEdit}
            isSubmitting={isSubmitting}
          />}

          <ModalDelete
            isOpen={isOpenModalDelete}
            toggle={()=>setIsOpenModalDelete(!isOpenModalDelete)}
            header={I18n.t('dashboard_delete-process')}
            text1={I18n.t('dashboard_sure-want-delete-process')}
            text2={I18n.t('dashboard_action-cannot-reversed')}
            event={()=>deleteProcess(processToRemove)}
            isSubmitting={removing}
          />

        </div>
      </Container>
    </div>
  )
}

export default Index